import beminize from 'bem-css-modules';
import cx from 'classnames';
import { Minus as IconMinus } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

// @ts-ignore
import { IconPlus } from 'common.components/icon2';

import { AccordionItemData } from '../typings';

// @ts-ignore
import styles from './accordion__item.module.scss';

const b = beminize(styles, 'accordion');

export interface Props extends AccordionItemData {
    isExpanded: boolean;
    isWithIcon?: boolean;
}

export const AccordionItem = (props: Props) => {
    const {
        isExpanded,
        isWithIcon,
        item: { previewContent, fullContent },
        title,
        onItemClick,
        id,
    } = props;

    const isInPreviewMode = Boolean(!isExpanded && previewContent);

    const handleItemClick = () => {
        if (onItemClick) {
            onItemClick(id);
        }
    };

    const getPreview = (): React.ReactNode => {
        if (!isInPreviewMode) {
            return null;
        }

        return <div className={b('item-collapsed-content')}>{previewContent}</div>;
    };

    const getHeader = (): React.ReactNode => {
        return (
            <div
                className={b('item-header', { expanded: isExpanded, preview: isInPreviewMode })}
                {...accessibleClick(handleItemClick)}
            >
                <div className={b('item-title', { preview: isInPreviewMode })}>
                    <Text size={isInPreviewMode ? Text.SIZE.S : Text.SIZE.L}>{title}</Text>
                    {getPreview()}
                </div>
                {isWithIcon && (
                    <div className={cx(b('item-icon'), 'qa_accordion-item-icon')}>
                        {isExpanded ? <IconMinus /> : <IconPlus />}
                    </div>
                )}
            </div>
        );
    };

    const getContent = (): React.ReactNode => {
        if (!isExpanded) {
            return null;
        }

        return <div className={b('item-content')}>{fullContent}</div>;
    };

    return (
        <div className={cx(b('item', { clickable: Boolean(onItemClick), expanded: isExpanded }), 'qa_accordion-item')}>
            {getHeader()}
            {getContent()}
        </div>
    );
};

AccordionItem.defaultProps = {
    isWithIcon: true,
};

export default AccordionItem;
